import client from "./client";

const getRestaurantsListFromApi = async (param) => {
  return await client.get(`/restaurants?${param}`);
}

const getParameters = (pagination, filter) => {
  let paramString = []

  if (filter.limit !== 0){
    paramString = [`limit=${filter.limit.toString()}`];
  }

  if (filter.qword.trim() !== "") {
    paramString.push(`q=${filter.qword}`);
  }

  if (filter.genres.trim() !== "") {
    paramString.push(`genres=${filter.genres}`);
  }

  if (filter.priceRangeValue[0] > 0 || filter.priceRangeValue[1] < 6) {
    let max = filter.priceRangeValue[1]
    let min = filter.priceRangeValue[0]
    let range = [max,min]
    for (let i = min+1; i < max; i++) {
      range.push(i)
    }
    paramString.push(`price_range=${range.toString()}`);
  }


  if (pagination) {
    paramString.push(`page=${pagination.page > 0 ? pagination.page - 1 : 0}`);
  }
  console.log("Requete Filtre : ," ,paramString)
  return paramString.join("&")
}
export default {
  getRestaurantInfoFromApi : async (id) => {
    return await client.get(`/restaurants/${id}`);
  },

  findRestaurants: async (pagination, filter) => {
    const param = getParameters(pagination, filter);
    return await getRestaurantsListFromApi(param);
  }
};

export const getRestaurantById = async (id) => {
  const URL = "https://ufoodapi.herokuapp.com/unsecure";
  const response = await fetch(`${URL}/restaurants/${id}`, {
    headers: {
      'Content-Type': 'application/json'
    },
  })

  return response.json();
}

export const getRestaurants = async () => {
  const URL = "https://ufoodapi.herokuapp.com/unsecure";
  const response = await fetch(`${URL}/restaurants/`, {
    headers: {
      'Content-Type': 'application/json'
    },
  })

  return response.json();
}
